<template>
  <div class="container text-center leaderboard-wrapper">
    <canvas
      id="firework-canvas"
      v-show="$store.state.slide.type == 'leaderboard' && data.audience
        && data.audience.totalPoint && data.index == 1 && !showWaitingScreen"
    />
    <div v-if="!showWaitingScreen" class="f-h">
      <div v-if="!isAudienceFormShowing" class="f-h">
        <div v-if="!loading" class="f-h">
          <div v-if="waitingLeadboard" class="f-h">
            <div v-if="!noResult" class="text-center waiting-leadeboard">
              <Loading />Let's see your score and ranking...
            </div>
            <div v-if="noResult" class="padding">
              <h2 v-if="$store.state.slide.title" class="mt-0 text-left slide-title-style">
                <span
                  :inner-html.prop="leaderboardTitleHTML"
                  v-if="isTitleLeaderboardVisible"
                />
              </h2>
              <div class="no-result-yet-text">
                {{ $t("noResultYet") }}
              </div>
            </div>

            <div class="audio-control-slide" v-if="$store.state.slide.audioLink && $store.state.slide.audioPlayOnAudience && $store.state.slide.id">
              <AudioControl />
            </div>
          </div>
          <div v-if="!waitingLeadboard" class="f-h fix-content-leaderboard">
            <QuizBrag
              v-if="data.lastSlide"
              :data="data"
              :teams="teams"
              :percentileTeam="getRankingForTeam.percentile"
              :isTeamQuiz="true"
            />

            <!-- Not win, has data.audience -->
            <div
              class="no-win m-b-8"
              v-if="!data.lastSlide"
            >
              <div class="title-leaderboard">
                <span
                  :inner-html.prop="leaderboardTitleHTML"
                  v-if="isTitleLeaderboardVisible"
                />
                <span class="count-player">
                  <span v-if="countPlayer < 2">{{ countPlayer || '...' }} {{ $t('team') }}</span>
                  <span v-if="countPlayer > 1">{{ countPlayer || '...' }} {{ $t('teams') }}</span>
                </span>
              </div>

              <QuizCounter
                :is-completed="true"
                :number-of-quizzes="totalQuiz"
                :number-of-quizzes-have-passed="currentQuiz"
                v-if="currentQuiz && data.audience"
              />

              <div
                class="mb-4"
                v-if="data.index && $store.state.presentation.language == 'en' && data.audience"
              >
                Your team is in the <strong>{{ data.index | countEnglish }}</strong>
                place out of <strong>{{ data.audiencesCount }}</strong> teams.
              </div>
              <div
                v-if="data.index && $store.state.presentation.language != 'en' && data.audience"
                class="mb-4"
                v-html="$t('yourTeamInPlaceTeams',
                           {msg: '<strong>' + data.indexFormat + '</strong>',
                            num: '<strong>' + data.audiencesCount + '</strong>'})"
              />
            </div>

            <!-- Not win, no data.audience -->
            <div class="no-win m-b-8" v-if="!data.audience">
              <div
                v-if="data.index && $store.state.presentation.language == 'en'"
                class="mb-4"
              >
                You got
                <strong>{{ data.index | countEnglish }}</strong>
                place out of <strong>{{ data.audiencesCount }}</strong> teams
              </div>
              <div
                v-if="data.index && $store.state.presentation.language != 'en'"
                class="mb-4"
                v-html="$t('yourTeamInPlaceTeams',
                           {msg: '<strong>' + data.indexFormat + '</strong>',
                            num: '<strong>' + data.audiencesCount + '</strong>'})"
              />
              <div
                class="mb-4"
                v-html="$t('teamHasntAnsweredAnyQuiz', {
                  msg: '<strong>0</strong>'
                })"
                v-if="!$store.state.slide.finalLeaderboard"
              />
              <div
                class="mb-4"
                v-html="$t('yourTeamScoreIs', {
                  msg: '<strong>0</strong>'
                })"
              />
            </div>

            <!-- Audio control -->
            <div
              class="audio-control-slide"
              v-if="$store.state.slide.audioLink &&
                $store.state.slide.audioPlayOnAudience && $store.state.slide.id"
            >
              <AudioControl />
            </div>

            <CtaButton
              :variant="$store.state.slide.textColour === '#ffffff' ? 'white' : 'dark'"
              v-if="data.lastSlide && teams.length"
              v-show="isLastSlide && showAhaSlidesCTA && isNotWhiteLabel"
              @click="handleClickOnButtonCTA()"
            />

            <!-- Button Next slide -->
            <div class="cta-wrapper" v-if="!isLastSlide && audiencePacing">
              <Buttonv2
                size="lg"
                block
                @click="handleClickNextSlide()"
              >
                <span>{{ $t('nextButton') }}</span>
                <AhaSvg
                  name="arrow-no-tail"
                  view-box="0 0 8 14"
                />
              </Buttonv2>
            </div>

            <div class="swich-individual" @click="switchShowRanking()">
              <span
                v-if="showIndividual === false && isHideIndividualLeaderboard !== true"
              >
                {{ $t('Show Individual Ranking') }}
              </span>
              <span v-if="showIndividual === true">{{ $t('Show Team Ranking') }}</span>
            </div>
            <ScoreLeaderboardContent
              type="team"
              :data="scoreLeaderBoard"
              v-if="showIndividual === false"
              @nextToWaitingScreen="handleWaitingScreen()"
            />
            <ScoreLeaderboardContent
              type="individual"
              :data="scoreLeaderBoard"
              v-if="showIndividual === true && isHideIndividualLeaderboard !== true"
              @nextToWaitingScreen="handleWaitingScreen()"
            />
          </div>
        </div>
        <div v-if="loading" class="horizontal layout center center-justified">
          <Loading />
        </div>
      </div>
      <QuizJoinGameForm v-if="isAudienceFormShowing" @joinGame="handleJoinGame" />
    </div>

    <div v-if="showWaitingScreen">
      <SlideWaiting />
    </div>
  </div>
</template>
<script>
import Config from '@/config'

import * as Sentry from '@sentry/vue'

import data from '@/assets/data/all.json'
import { mapState } from 'vuex'

import Constant from '@/constant'
import { EmojiIndex } from 'emoji-mart-vue-fast'
import SlideWaiting from '@/components/SlideWaiting.vue'
import Loading from '@/components/Loading.vue'
import Util from '@/util'
import EventBus from '@/eventBus'
import AudioControl from '@/components/AudioControl.vue'
import QuizJoinGameForm from '@/components/QuizJoinGameForm.vue'

import ScoreLeaderboardContent from '@/components/types/ScoreLeaderboardContent.vue'
import Buttonv2 from '@/components/UI/Buttonv2.vue'

// components
import QuizCounter from '@/components/common/QuizCounter.vue'
import CtaButton from '@/components/common/CtaButton.vue'
import QuizBrag from '@/components/quiz/QuizBrag.vue'

// containers
import QuizCounterContainer from '@/containers/common/QuizCounter'

// Utils
import {
  getTeamCount,
  getRankingByTeamId,
  getTeamMemberRankingWithinATeamByTeamIdAndAudienceId,
} from '@/components/utils/leaderboard'

const cutOff = 10

export default {
  components: {
    SlideWaiting,
    Loading,
    AudioControl,
    QuizJoinGameForm,
    ScoreLeaderboardContent,
    Buttonv2,
    CtaButton,
    QuizCounter: QuizCounterContainer(QuizCounter),
    QuizBrag,
  },
  data() {
    return {
      openEmoji: false,
      submiting: false,
      error: false,
      audienceName: this.$store.state.audienceName,
      data: {},
      leaderboardData: {},
      intervalFirework: null,
      showWaitingScreen: false,
      myReq: null,
      loading: true,
      waitingLeadboard: true,
      noResult: false,
      lastSlide: false,
      emojiIndex: null,
      currentQuiz: null,
      totalQuiz: null,
      showMore: false,
      countMore: 0,
      last: {},
      scoreLeaderBoard: [],
      showIndividual: false,
      fullData: null,
      countPlayer: 0,
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      audiencePacing: (state) => state.presentation.audiencePacing,
      presentationID: (state) => state.presentation.id,
      showAhaSlidesCTA: (state) => state.presentation.showAhaSlidesCTA,
      slideActive: (state) => state.slide,
      isNotWhiteLabel: (state) => {
        return state.presentation.planType !== 'white-label'
      },
      isLastSlide: (state) => {
        return state.slide.id === state.presentation.lastSlide
      },
      isFinalLeaderboard: (state) => {
        let isFinalLeaderboard = false
        if (state.slides) {
          const slidesQuiz = state.slides.filter((item) => {
            return item.type === 'pickAnswer'
          })

          const index = state.slides.findIndex((item) => item.id === state.slide.id)
          let indexQuiz = 0
          if (slidesQuiz.length) {
            indexQuiz = state.slides.findIndex(
              (item) => item.id === slidesQuiz[slidesQuiz.length - 1].id,
            )
          }
          if (index > indexQuiz) {
            isFinalLeaderboard = true
          }
        }

        return isFinalLeaderboard
      },
      isHideIndividualLeaderboard: (state) => {
        if (state.presentation && state.presentation.isHideIndividualLeaderboard) {
          return state.presentation.isHideIndividualLeaderboard
        }
        return false
      },
    }),
    isAudienceFormShowing() {
      return !this.$store.state.audienceName || !this.$store.state.isAudienceEmojiDisabled
    },
    getTotalTeam() {
      return getTeamCount(this.leaderboardData)
    },
    getRankingForTeam() {
      return getRankingByTeamId(this.leaderboardData, this.$store.state.audienceQuizTeam)
    },
    getRankingForAudienceWithinTeam() {
      return getTeamMemberRankingWithinATeamByTeamIdAndAudienceId(
        this.leaderboardData,
        this.$store.state.audienceQuizTeam,
        this.$store.state.audienceId,
      )
    },
    isTitleLeaderboardVisible() {
      const { title } = this.slideActive
      return title == null || (title && title.trim().length)
    },
    leaderboardTitleHTML() {
      return this.slideActive.titleHTML || this.slideActive.title || 'Leaderboard'
    },
  },
  destroyed() {
    if (this.myReq) {
      window.cancelAnimationFrame(this.myReq)
    }
    EventBus.$off('answer-quiz')
  },
  mounted() {
    this.emojiIndex = new EmojiIndex(data)

    if (this.$store.state.audienceName) {
      this.getResult()
    } else {
      this.loading = false
    }

    EventBus.$on('answer-quiz', (data) => {
      if (this.$store.state.audienceName && this.waitingLeadboard) {
        this.handleDataSuccess(data)
      }
    })

    if (this.$store.state.slide.id == this.$store.state.presentation.lastSlide) {
      this.lastSlide = true
    }

    // Firing confetti effect only available if the canvas element is mounted to the DOM
    const canvas = document.getElementById('firework-canvas')
    const colors = Constant.colorsHex.filter((item, key) => {
      return item && key < 7
    })

    this.startConfettiEffect = Util.setupConfettiEffect(canvas, { resize: true },
      {
        startVelocity: 5,
        spread: 360,
        ticks: 100,
        decay: 0.98,
        particleCount: 40,
        shapes: ['circle'],
        colors,
        zIndex: 100,
      })
  },
  methods: {
    handleWaitingScreen() {
      this.showWaitingScreen = true
    },
    switchShowRanking() {
      if (this.showIndividual === null) return
      this.showIndividual = !this.showIndividual
      this.showScoreRanking(this.showIndividual)
    },

    showScoreRanking(showIndividual) {
      this.showIndividual = null
      setTimeout(() => {
        this.showIndividual = showIndividual
        if (this.showIndividual) {
          this._createDataShowListScoreIndividual(this.fullData)
        } else {
          this._createDataShowListScore(this.fullData)
        }
      }, 200)
    },
    getColor(team) {
      return team.color || Util.getAhaColor(team.id)
    },
    _createDataShowListScoreIndividual(doc) {
      let total = 0
      if (doc.audiences.length) {
        total = doc.audiences[0].t
      }

      doc.audiences.forEach((item, key) => {
        item.color = Constant.colors[key % 30]
        item.oldPercent = (item.t / total) * 100 || 1
      })

      this.scoreLeaderBoard = doc.audiences
    },
    _createDataShowListScore(doc) {
      doc.teams.forEach((team) => {
        team.color = this.getColor(team)

        team.members = doc.audiences.filter((au) => {
          return au.g === team.id
        })
      })
      let total = 0
      if (doc.teams.length) {
        total = doc.teams[0].t
      }
      doc.teams.forEach((item) => {
        item.oldPercent = (item.t / total) * 100 || 1
      })
      this.scoreLeaderBoard = doc.teams
      this.countPlayer = doc.teams.length
    },
    async getResult() {
      this.loading = true

      try {
        let doc
        if (this.$store.state.presentation.audiencePacing) {
          const res = await this.$http.post(Config.api.createLeaderboard, {
            slideId: this.$store.state.slide.id,
            isFinalLeaderboard: this.isFinalLeaderboard,
          })
          doc = res.body
        } else {
          const url = this.$store.state.slide.cacheLeaderboardUrl
          if (!url) {
            this.loading = false
            this.noResult = true
            return
          }
          const res = await this.$http.get(url)
          doc = res.body
        }

        this.loading = false

        if (!doc.id) {
          doc.teams = []
        }
        if (!doc.teams.length) {
          this.noResult = true
          return
        }
        this.teams = doc.teams
        this.handleDataSuccess(doc)
        this.currentQuiz = doc.currentQuiz
        this.totalQuiz = doc.totalQuiz
        this._createDataShowListScore(doc)
        this.fullData = doc
      } catch (err) {
        this.noResult = true
        this.loading = false
        Sentry.captureException(err)
      }
    },

    handleDataSuccess(doc) {
      if (!doc.id || doc.loading) {
        this.waitingLeadboard = true
        return
      }
      this.leaderboardData = doc
      this.waitingLeadboard = false
      const index = doc.teams.findIndex((item) => {
        return item.id == this.$store.state.audienceQuizTeam
      })

      if (index === -1) {
        this.data.totalQuiz = Util.numberWithCommas(doc.totalQuiz)
      }

      if (index != -1) {
        const audience = doc.teams[index]
        this.data.audience = {
          audience: this.audienceId,
          audienceEmoji: this.$store.state.audienceEmoji,
          audienceName: this.$store.state.audienceName,
          index: audience.i,
          totalPoint: audience.t,
          teams: doc.audiences.filter((item) => {
            return item.g === audience.id
          }),
          correctRate: audience.cR || 0,
        }
        this.data.index = audience.i
        this.data.audience.totalPoint = Util.numberWithCommas(this.data.audience.totalPoint)
        this.data.indexFormat = Util.numberWithCommas(audience.i)
        this.data.totalQuiz = Util.numberWithCommas(doc.totalQuiz)
      }
      this.data.lastSlide = doc.lastSlide
      this.data.audiencesCount = Util.numberWithCommas(doc.teams.length)
      if (this.data.lastSlide) {
        this.$store.state.slide.finalLeaderboard = true
      }

      // Show more
      const teams = this.data && this.data.audience && this.data.audience.teams
      if (teams && teams.length > cutOff + 2) {
        this.countMore = teams.length - cutOff
        this.last = teams[teams.length - 1]
      }

      if (
        this.data.lastSlide &&
        this.data.audience &&
        this.data.audience.totalPoint &&
        this.data.index == 1
      ) {
        const self = this
        if (!this.startConfettiEffect) {
          return
        }

        let start = null

        // eslint-disable-next-line
        function step(timestamp) {
          if (!start) start = timestamp
          const progress = timestamp - start
          if (progress > 1200) {
            start = null
            self.startConfettiEffect({
              x: Math.random(),
              y: Math.random() - 0.3,
            })
          }
          self.myReq = window.requestAnimationFrame(step)
        }
        self.myReq = window.requestAnimationFrame(step)
      }
    },
    handleJoinGame() {
      this.getResult()
    },
    onChangeAudienceName() {
      this.error = false
    },
    openPickEmoji() {
      this.openEmoji = !this.openEmoji
    },
    clickOutSideEmoji() {
      if (this.openEmoji) {
        this.openEmoji = false
      }
    },
    addEmoji(emoji) {
      this.$store.state.audienceEmoji = emoji.native
      this.openEmoji = false
    },
    showMeMore() {
      this.showMore = true
    },
    shouldShowMore(teams) {
      if (!teams) {
        return []
      }
      if (teams.length <= 12) {
        return teams
      }

      if (this.showMore) {
        return teams.slice(0, teams.length - 1)
      }
      return teams.slice(0, cutOff)
    },
    handleClickOnButtonCTA() {
      window.open(Util.generateButtonCTAURL(this.presentationID, this.slideActive, 'leaderboard_CTA'), '_blank')
      Util.trackGAButtonCTA(this.presentationID, this.slideActive)
    },
    handleClickNextSlide() {
      EventBus.$emit('skipSlide')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.mb-4 {
  margin-bottom: 8px;
}

.bold.list-team-member {
  line-height: 30px;
  margin: 16px 0;
  font-size: 22px;
  span {
    margin-right: 10px;
    &:not(:last-child):after {
      content: ",";
    }

    &:last-child {
      margin-right: 0;
    }
  }
}

.show-more {
  text-decoration: underline;
  cursor: pointer;
  z-index: 9999;
  position: relative;
}
.swich-individual {
  cursor: pointer;
  text-decoration: underline;
  margin-bottom: 8px;
}
.count-player {
  margin-left: 3px;
}
.cta-wrapper {
  width: 100%;
  max-width: 400px;
  margin: 16px auto;
}

.title-leaderboard {
  p {
    margin-top: 0;
  }
}
</style>
